import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'shadow',
      d: 'M1.5,-0.5h0.5v0.5h-0.5zM-4.5,0h0.5v0.5h-0.5zM-3.5,0h0.5v0.5h-0.5zM2,0h1v0.5h-1zM3.5,0h1v0.5h-1zM2,0.5h0.5v0.5h-0.5zM4,0.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'cherryTrunk',
      d: 'M-4,-7.5h1v0.5h-1zM1,-7.5h3v0.5h-3zM-4,-7h1.5v0.5h-1.5zM0,-7h3v0.5h-3zM-4,-6.5h2v0.5h-2zM0,-6.5h2.5v0.5h-2.5zM-3.5,-6h0.5v0.5h-0.5zM-2.5,-6h1v0.5h-1zM-0.5,-6h2v0.5h-2zM-3,-5.5h0.5v1h-0.5zM-1.5,-5.5h0.5v0.5h-0.5zM-0.5,-5.5h1.5v0.5h-1.5zM-1,-5h2v0.5h-2zM-2.5,-4.5h0.5v0.5h-0.5zM-0.5,-4.5h1.5v0.5h-1.5zM-2,-4h0.5v1h-0.5zM-0.5,-4h1v1h-1zM-2,-3h1v2.5h-1zM0,-3h0.5v1h-0.5zM0,-2h1v1h-1zM0,-1h1.5v1h-1.5zM-2.5,-0.5h1.5v0.5h-1.5zM-3,0h1.5v0.5h-1.5zM0.5,0h1.5v1h-1.5zM-3,0.5h3v0.5h-3zM-2.5,1h1v0.5h-1z',
    },
    {
      paint: 'cherryBranch',
      d: 'M-3,-6h0.5v0.5h-0.5zM-2.5,-5.5h1v0.5h-1zM-2.5,-5h1.5v0.5h-1.5zM-2,-4.5h1.5v0.5h-1.5zM-1.5,-4h1v1h-1zM-1,-3h1v3h-1zM-1.5,0h2v0.5h-2zM0,0.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'flowerAlt',
      d: 'M-2.5,-14.5h2.5v0.5h-2.5zM0.5,-14.5h2v0.5h-2zM-3,-14h6v0.5h-6zM-4,-13.5h2v0.5h-2zM2.5,-13.5h1.5v0.5h-1.5zM-5,-13h2.5v0.5h-2.5zM3,-13h2.5v0.5h-2.5zM-5,-12.5h1v0.5h-1zM4.5,-12.5h1v0.5h-1zM-5,-12h0.5v0.5h-0.5zM5,-12h0.5v0.5h-0.5zM-5.5,-11.5h1v0.5h-1zM5,-11.5h1v1h-1zM-6,-11h1v0.5h-1zM-6.5,-10.5h0.5v1.5h-0.5zM5.5,-10.5h1v1.5h-1zM-6.5,-9h1v0.5h-1zM-4.5,-9h1.5v0.5h-1.5zM-0.5,-9h2v0.5h-2zM4.5,-9h2v0.5h-2zM-6.5,-8.5h4.5v0.5h-4.5zM-1.5,-8.5h4v0.5h-4zM3,-8.5h3.5v0.5h-3.5zM-6,-8h2v0.5h-2zM-3.5,-8h2.5v0.5h-2.5zM1,-8h3v0.5h-3zM4.5,-8h1.5v0.5h-1.5zM-6,-7.5h1v0.5h-1zM4.5,-7.5h1v0.5h-1z',
    },
    {
      paint: 'cherryPetalPink',
      d: 'M2.5,-13h0.5v0.5h-0.5zM2,-12.5h2.5v0.5h-2.5zM-1,-12h6v0.5h-6zM-4.5,-11.5h9.5v0.5h-9.5zM-5,-11h10v0.5h-10zM-6,-10.5h9v0.5h-9zM4,-10.5h1.5v0.5h-1.5zM-6,-10h0.5v0.5h-0.5zM-4.5,-10h4v0.5h-4zM0,-10h5.5v0.5h-5.5zM-6,-9.5h11.5v0.5h-11.5zM-5.5,-9h1v0.5h-1zM-3,-9h2.5v0.5h-2.5zM1.5,-9h3v0.5h-3zM-2,-8.5h0.5v0.5h-0.5zM2.5,-8.5h0.5v0.5h-0.5zM-5.5,-6h1v0.5h-1zM-5.5,-5.5h1.5v0.5h-1.5zM-5,-5h0.5v0.5h-0.5zM4,-5h1v1h-1zM-3.5,-3h1v1h-1zM-4,0h0.5v0.5h-0.5zM3,0h0.5v0.5h-0.5zM-4.5,0.5h1.5v0.5h-1.5zM2.5,0.5h1.5v1h-1.5zM-4,1h1v0.5h-1zM0.5,1h1.5v0.5h-1.5zM1,1.5h1v0.5h-1z',
    },
    {
      paint: 'cherryPetalWhite',
      d: 'M-2,-13.5h4.5v0.5h-4.5zM-2.5,-13h5v0.5h-5zM-4,-12.5h6v0.5h-6zM-4.5,-12h3.5v0.5h-3.5zM3,-10.5h1v0.5h-1zM-5.5,-10h1v0.5h-1zM-0.5,-10h0.5v0.5h-0.5z',
    },
  ],
  pixels: 465,
};
export const sprites: readonly PixelSprite[] = [variant0];
